import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { EVWriteBackStatus } from "../../../enums/evBvWriteBackStatus";
import { InfoIcon } from "../../../svg/info-icon";

interface SigBoxNoteModalProps {
  lastUpdateStatus?: string;
  notes?: string;
  onClose: () => void;
  onSave: (note: string) => void;
}

const SigBoxNoteModal = (props: SigBoxNoteModalProps) => {
  const [notes, setNotes] = useState(props.notes);

  const returnColoredTextForStatus = (status?: string) => {
    if (status === EVWriteBackStatus.SUCCESS) {
      return <span className="font-bold text-primaryGreen-4">Success</span>;
    } else if (status === EVWriteBackStatus.ERROR) {
      return <span className="text-tertiaryRed-4">Failed</span>;
    } else if (status === EVWriteBackStatus.IN_PROGRESS) {
      return <span className="text-secondaryYellow-4">In Progress</span>;
    } else {
      return <span className="text-primaryGray-4">N/A</span>;
    }
  };

  const handleSave = () => {
    props.onSave(notes ?? "");
    props.onClose();
  };
  return (
    <Modal
      dialogId={"sig-box-note-modal"}
      onSave={handleSave}
      title={"Sigbox Notes"}
      saveButtonText={
        props.lastUpdateStatus === EVWriteBackStatus.IN_PROGRESS
          ? "Updating..."
          : "Add to Sig Box"
      }
      cancelText={"Cancel"}
      disableSave={
        props.lastUpdateStatus === EVWriteBackStatus.IN_PROGRESS ||
        props.lastUpdateStatus === EVWriteBackStatus.SUCCESS
      }
      onClose={props.onClose}
      onCancel={props.onClose}
    >
      <div className="sig-box__container flex flex-col gap-1">
        <div className="sig-box__last-status ml-auto text-tiny">
          Last Update Status :{" "}
          <span className="font-bold">
            {returnColoredTextForStatus(props.lastUpdateStatus)}
          </span>
        </div>
        <div className="sig-box__notes">
          <div className="sig-box__notes-label mb-1 text-tiny">Notes</div>
          <div className="sig-box__notes-textarea">
            <textarea
              className="sig-box__notes-textarea-input w-full rounded border border-primaryGray-14 px-3 py-2 text-tiny outline-none"
              rows={5}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
        </div>
        <div className="sig-box__hint-text flex items-center gap-1 text-tiny italic text-primaryGray-6">
          <InfoIcon />
          Verify and edit notes before adding to sigbox
        </div>
      </div>
    </Modal>
  );
};

export default SigBoxNoteModal;
